import React, { Component } from "react";
import {
  withRouter
} from 'react-router-dom';

import { Navigation } from "@shopify/polaris";
import './index.css'
import {
  // HomeMajor,
  // SearchMinor,
  // EditMinor,
  // AutomationMajor
} from '@shopify/polaris-icons';
// import SeoCheckerIcon from '../../../assets/SeoCheckerIcon';
// import StructuredDataIcon from '../../../assets/StructuredDataIcon';
// import ImageIcon from '../../../assets/ImageIcon';
// import HtmlSitemapIcon from '../../../assets/HtmlSitemapIcon';
// import ExchangeBacklinkIcon from '../../../assets/ExchangeBacklinkIcon';
// import GoogleIcon from '../../../assets/GoogleIcon';
// import SeoAMPServiceIcon from '../../../assets/SeoAMPServiceIcon';
// import KeywordsResearchIcon from '../../../assets/KeywordsResearchIcon';
// import ControlScriptsIcon from '../../../assets/ControlScriptsIcon';
// import PageSpeedIcon from "../../../assets/PageSpeedIcon";
import BrokenLinksIcon from '../../../assets/BrokenLinksIcon';
// import MoneyIcon from '../../../assets/MoneyIcon';
// import IntegrationIcon from '../../../assets/IntegrationIcon';
// import FeatureRequestIcon from "../../../assets/FeatureRequestIcon";
// import GuideIcon from "../../../assets/GuideIcon";
import SearchAppearanceIcon from "../../../assets/SearchAppearance";

import utils from '../../../utils/utils';

import Language from '../../../i18n/Language';
// import SiteVerifyIcon from "../../../assets/DashboardV2/SiteVerifyIcon";
import DashboardIcon from "../../../assets/NavigationIconList/DashboardIcon";
import SEOCheckerIcon from "../../../assets/NavigationIconList/SEOCheckerIcon";
import SpeedOptIcon from "../../../assets/NavigationIconList/SpeedOptIcon";
import OnpageIcon from "../../../assets/NavigationIconList/OnpageIcon";
// import HTMLsitemapIcon from "../../../assets/NavigationIconList/HTMLsitemapIcon";
// import ExchangeIcon from "../../../assets/NavigationIconList/ExchangeIcon";
// import AMPIcon from "../../../assets/NavigationIconList/AMPIcon";
// import GSearchIcon from "../../../assets/NavigationIconList/GSearchIcon";
// import KeywordsIcon from "../../../assets/NavigationIconList/KeywordsIcon";
import PricingIcon from "../../../assets/NavigationIconList/PricingIcon";
import ReportIcon from "../../../assets/NavigationIconList/ReportIcon";
import SettingsIcon from "../../../assets/SettingsIcon";
import SeoCheckerIcon from "../../../assets/SeoCheckerIcon";

const t = Language

// const newIcon = <span style={{ position: 'absolute', top: "0", right: "0" }}><svg t="1608603465778" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7978" width="26" height="26"><path d="M1020.586667 413.013333l-409.6-409.6c-3.413333 0-10.24-3.413333-13.653334-3.413333H17.066667C10.24 0 3.413333 3.413333 0 10.24c0 6.826667 0 13.653333 3.413333 20.48l989.866667 989.866667c3.413333 3.413333 6.826667 3.413333 13.653333 3.413333h6.826667c6.826667-3.413333 10.24-10.24 10.24-17.066667v-580.266666c0-3.413333-3.413333-10.24-3.413333-13.653334zM464.213333 334.506667c-3.413333 0-6.826667 0-6.826666-3.413334-6.826667-3.413333-10.24-10.24-6.826667-17.066666l34.133333-160.426667-92.16 92.16c-6.826667 6.826667-17.066667 6.826667-23.893333 0-6.826667-6.826667-6.826667-17.066667 0-23.893333l133.12-133.12c6.826667-6.826667 13.653333-6.826667 20.48-3.413334s10.24 10.24 6.826667 17.066667l-34.133334 160.426667L587.093333 170.666667c6.826667-6.826667 17.066667-6.826667 23.893334 0 6.826667 6.826667 6.826667 17.066667 0 23.893333L477.866667 324.266667c-6.826667 10.24-10.24 10.24-13.653334 10.24z m143.36 34.133333l-37.546666-37.546667-37.546667 37.546667 54.613333 54.613333c6.826667 6.826667 6.826667 17.066667 0 23.893334-3.413333 3.413333-6.826667 3.413333-13.653333 3.413333s-10.24 0-13.653333-3.413333l-68.266667-68.266667c-6.826667-6.826667-6.826667-17.066667 0-23.893333l133.12-133.12c3.413333-3.413333 6.826667-6.826667 13.653333-3.413334 3.413333 0 10.24 3.413333 13.653334 3.413334l71.68 71.68c6.826667 6.826667 6.826667 17.066667 0 23.893333s-17.066667 6.826667-23.893334 0l-61.44-61.44L597.333333 307.2l37.546667 37.546667c6.826667 6.826667 6.826667 17.066667 0 23.893333-3.413333 3.413333-6.826667 3.413333-13.653333 3.413333s-10.24 0-13.653334-3.413333z m290.133334 122.88l-157.013334 105.813333c-3.413333 3.413333-6.826667 3.413333-10.24 3.413334-3.413333 0-6.826667 0-10.24-3.413334-6.826667-3.413333-6.826667-10.24-6.826666-17.066666l27.306666-98.986667-88.746666 34.133333c-6.826667 3.413333-13.653333 0-20.48-6.826666-3.413333-6.826667-3.413333-13.653333 0-20.48l105.813333-157.013334c6.826667-6.826667 17.066667-10.24 23.893333-3.413333 6.826667 6.826667 10.24 17.066667 3.413334 23.893333l-75.093334 112.64 71.68-27.306666c6.826667-3.413333 13.653333 0 17.066667 3.413333s6.826667 10.24 3.413333 17.066667l-23.893333 88.746666 119.466667-81.92c6.826667-6.826667 17.066667-3.413333 23.893333 3.413334 6.826667 6.826667 3.413333 20.48-3.413333 23.893333z" fill="#008000" p-id="7979"></path></svg></span>;

const aiIcon = <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_1_2)">
    <path d="M25.9133 10.4867L15.5133 0.0866667C15.4267 0.0866667 15.2533 0 15.1667 0H0.433333C0.26 0 0.0866667 0.0866667 0 0.26C0 0.433333 0 0.606667 0.0866667 0.78L25.22 25.9133C25.3067 26 25.3933 26 25.5667 26H25.74C25.9133 25.9133 26 25.74 26 25.5667V10.8333C26 10.7467 25.9133 10.5733 25.9133 10.4867ZM11.7867 8.49333C11.7 8.49333 11.6133 8.49333 11.6133 8.40667C11.44 8.32 11.3533 8.14667 11.44 7.97333L12.3067 3.9L9.96667 6.24C9.79333 6.41333 9.53333 6.41333 9.36 6.24C9.18667 6.06667 9.18667 5.80667 9.36 5.63333L12.74 2.25333C12.9133 2.08 13.0867 2.08 13.26 2.16667C13.4333 2.25333 13.52 2.42667 13.4333 2.6L12.5667 6.67333L14.9067 4.33333C15.08 4.16 15.34 4.16 15.5133 4.33333C15.6867 4.50667 15.6867 4.76667 15.5133 4.94L12.1333 8.23333C11.96 8.49333 11.8733 8.49333 11.7867 8.49333ZM15.4267 9.36L14.4733 8.40667L13.52 9.36L14.9067 10.7467C15.08 10.92 15.08 11.18 14.9067 11.3533C14.82 11.44 14.7333 11.44 14.56 11.44C14.3867 11.44 14.3 11.44 14.2133 11.3533L12.48 9.62C12.3067 9.44667 12.3067 9.18667 12.48 9.01333L15.86 5.63333C15.9467 5.54667 16.0333 5.46 16.2067 5.54667C16.2933 5.54667 16.4667 5.63333 16.5533 5.63333L18.3733 7.45333C18.5467 7.62667 18.5467 7.88667 18.3733 8.06C18.2 8.23333 17.94 8.23333 17.7667 8.06L16.2067 6.5L15.1667 7.8L16.12 8.75333C16.2933 8.92667 16.2933 9.18667 16.12 9.36C16.0333 9.44667 15.9467 9.44667 15.7733 9.44667C15.6 9.44667 15.5133 9.44667 15.4267 9.36ZM22.7933 12.48L18.8067 15.1667C18.72 15.2533 18.6333 15.2533 18.5467 15.2533C18.46 15.2533 18.3733 15.2533 18.2867 15.1667C18.1133 15.08 18.1133 14.9067 18.1133 14.7333L18.8067 12.22L16.5533 13.0867C16.38 13.1733 16.2067 13.0867 16.0333 12.9133C15.9467 12.74 15.9467 12.5667 16.0333 12.3933L18.72 8.40667C18.8933 8.23333 19.1533 8.14667 19.3267 8.32C19.5 8.49333 19.5867 8.75333 19.4133 8.92667L17.5067 11.7867L19.3267 11.0933C19.5 11.0067 19.6733 11.0933 19.76 11.18C19.8467 11.2667 19.9333 11.44 19.8467 11.6133L19.24 13.8667L22.2733 11.7867C22.4467 11.6133 22.7067 11.7 22.88 11.8733C23.0533 12.0467 22.9667 12.3933 22.7933 12.48Z" fill="#008000" />
    <path d="M13.5 1C14 1 24.5 12 25 12.5L19 18L13 11.5L6.5 4C8.66667 3 13.1 1 13.5 1Z" fill="#008000" />
    <path d="M17.6405 6.22562L14.9616 7.44537L16.2715 8.79537L17.6405 6.22562ZM18.9697 5.77895L16.1473 11.3528C16.0031 11.6307 15.9055 11.9092 15.8474 12.1495C15.79 12.3431 15.7944 12.5688 15.8761 12.8267L15.7182 12.9799L14.2399 11.4562L14.3977 11.303C14.6665 11.5327 14.957 11.3582 15.2218 10.8254L16.0153 9.27381L14.468 7.67907L12.9798 8.3567C12.3452 8.6505 12.123 8.94275 12.3449 9.18725L12.187 9.34045L10.9997 8.11676L11.1576 7.96357C11.3278 8.02837 11.5532 8.03955 11.7717 7.99618C11.9981 7.94514 12.3577 7.82611 12.8271 7.6465L18.5024 5.29737L18.9697 5.77895Z" fill="white" />
    <path d="M16.2266 13.5039L16.3845 13.3507C16.5704 13.4002 16.8119 13.3805 17.0463 13.3062C17.2576 13.2239 17.5014 13.0486 17.7698 12.7882L20.6277 10.0153C20.8962 9.75489 21.0787 9.5165 21.1674 9.3078C21.2487 9.07566 21.2757 8.83491 21.2397 8.63989L21.3897 8.49436L22.914 10.0654L22.764 10.2109C22.5625 10.1612 22.3287 10.1888 22.0942 10.2631C21.883 10.3454 21.6392 10.5207 21.3707 10.7811L18.5128 13.554C18.2444 13.8144 18.0619 14.0528 17.9732 14.2615C17.8919 14.4936 17.8573 14.7265 17.9088 14.9217L17.7509 15.0749L16.2266 13.5039Z" fill="white" />
  </g>
  <defs>
    <clipPath id="clip0_1_2">
      <rect width="26" height="26" fill="white" />
    </clipPath>
  </defs>
</svg>


class NavigationRoute extends Component {
  state = {
    Language: 'en', // 默认英文

    // 顶部导航栏url
    topUrl: '',
    //监听屏幕
    wInnerWidth: window.innerWidth,

    isExpandedNav: true, // 是否展开左侧导航栏
    ishoverExpandeNav: false, // 是否触摸展开导航栏
    isShowNavIcon: true, // 是否展示菜单new||hot图标

    isShowShadeBlock: false, // 是否显示遮罩层

  }


  UNSAFE_componentWillMount() {
    // 默认展开导航栏
    window.isExpandedNav = true;
    window.isHoverChange = false;
    window.isShowNavIcon = true;

    this.setState({
      isExpandedNav: Boolean(window.isExpandedNav) ? window.isExpandedNav : false,
      isShowNavIcon: Boolean(window.isShowNavIcon) ? window.isShowNavIcon : false,
      isShowShadeBlock: window.innerWidth <= 769 && !(window.shopify) ? true : false, // 遮罩层
    }, () => {
      if (Boolean(window.isExpandedNav) && Boolean(!window.isHoverChange) && window.innerWidth > 768) {
        // document.getElementById('SEOpage_content').style.paddingLeft = '24rem';
        const SEOContent = document.getElementById('SEOpage_content');
        const TabsPublic = document.getElementById('TabsPublic');
        Boolean(SEOContent) && (SEOContent.style.paddingLeft = '15rem');
        Boolean(TabsPublic) && (TabsPublic.style.paddingLeft = '15rem');
      }
    })

  }

  //进入页面调用接口
  componentDidMount() {
    window.addEventListener('resize', this.reSize, true);

    // 传递内部this出去
    if (this.props.toggleNavAction) {
      this.props.toggleNavAction(this);
    }
    window.NavMenu = this;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.reSize);
    this.setState = () => false;
  }

  // 屏幕监听
  reSize = () => {
    let wWidth = window.innerWidth;
    this.setState({
      wInnerWidth: wWidth,
      isShowShadeBlock: wWidth <= 769 && this.state.isExpandedNav && !(window.shopify) ? true : false
    })
  }

  // 鼠标进入左侧导航栏
  hoverLeftNavList = () => {
    if (!this.state.isExpandedNav) {
      window.isExpandedNav = true;
      window.isShowNavIcon = true;
      window.isHoverChange = true;
      setTimeout(() => {
        this.setState({
          isShowNavIcon: true,
        })
      }, 200)
    }
  }
  // 鼠标离开左侧导航栏
  leaveLeftNavList = () => {
    if (!this.state.isExpandedNav) {
      setTimeout(() => {
        this.setState({
          isShowNavIcon: false,
        })
      }, 200)
    }
    if (Boolean(window.isHoverChange)) {
      this.setState({
        isShowNavIcon: false,
        isExpandedNav: false,
      })
      window.isExpandedNav = false;
      window.isShowNavIcon = false;
    }
  }

  // 伸缩导航栏
  toggleNavMenusAction = (states = false) => {
    if (states) {
      // 需要增加新手引导状态
      if (this.state.isExpandedNav) {
        return false;
      }
    }
    // 添加类名
    const SEOContent = document.getElementById('SEOpage_content');
    const TabsPublic = document.getElementById('TabsPublic');
    if (Boolean(SEOContent)) {
      SEOContent.style.paddingLeft = '';
      TabsPublic.style.paddingLeft = '';
      if (!this.state.isExpandedNav) {
        SEOContent.classList.add('NavSeo-Frame__Content', 'NavSeo-Frame__Content--isExpanded');
        TabsPublic.classList.add('NavSeo-Frame__Content', 'NavSeo-Frame__Content--isExpanded');
      } else {
        SEOContent.classList.add('NavSeo-Frame__Content');
        SEOContent.classList.remove('NavSeo-Frame__Content--isExpanded');
        TabsPublic.classList.add('NavSeo-Frame__Content');
        TabsPublic.classList.remove('NavSeo-Frame__Content--isExpanded');
      }
      this.setState({
        isExpandedNav: !this.state.isExpandedNav,
        isShowNavIcon: !this.state.isExpandedNav ? true : false,
      }, () => {
        window.isExpandedNav = this.state.isExpandedNav;
        window.isShowNavIcon = this.state.isShowNavIcon;
        window.isHoverChange = false;
      })
    }
  }

  // 关闭导航栏
  closeNavBlock = (states = false) => {
    if (this.state.wInnerWidth <= 769) {
      this.setState({
        isExpandedNav: states,
        isShowNavIcon: states,
        isShowShadeBlock: states, // 遮罩层
      }, () => {
        if (!states && Boolean(window.topBarAction)) {
          window.topBarAction.changeNavStatus();
        }
      })
    }
  }

  // 跳转
  jumpPageUrl = (url) => {
    window.savebarState = false;
    utils.routeJump(this, url)
  }

  render() {
    const {
      state: {
        wInnerWidth,
        isExpandedNav,
        Language,
        isShowShadeBlock,

      },

    } = this;

    const path_url = window.location.pathname;
    const navigationMarkup = wInnerWidth < 10086 ? (
      <>
        {(isShowShadeBlock && !(window.shopify)) && <div className="shade_block" onClick={() => this.closeNavBlock(false)}></div>}
        <div id="NavigationMenu" className={`${Language} Polaris-Navigation__PrimaryNavigation__Content NavSeo-ScrollBar--isSubdued NavSeo-Frame__Navigation ${isExpandedNav ? 'NavSeo-Frame__Navigation--isExpanded' : ''} ${wInnerWidth <= 768 ? 'mobileNavMenu' : ''}`} onClick={(e) => e.preventDefault()} onMouseEnter={() => this.hoverLeftNavList()} onMouseLeave={() => this.leaveLeftNavList()}>
          <Navigation location="/">
            <Navigation.Section
              // separator
              items={[
                {
                  label: t("Dashboard"),
                  icon: DashboardIcon,
                  key: 'dashboard',
                  url: '/dashboard',
                  matches: Boolean(path_url === '/dashboard'),
                  onClick: () => {
                    this.jumpPageUrl('/dashboard')
                  }
                },
                {
                  label: t("SEO Checker"),
                  icon: SeoCheckerIcon,
                  url: '/website-check',
                  matches: Boolean(path_url === '/website-check'),
                  onClick: () => {
                    this.jumpPageUrl('/website-check')
                  },
                },
              ]}
            />
            <Navigation.Section
              separator
              items={[
                {
                  label: t("Speed Optimization"),
                  icon: SpeedOptIcon,
                  url: "/speedOpt",
                  // matches: true,
                  // matches: Boolean(path_url === "/speedOpt"),
                  onClick: () => {
                    this.jumpPageUrl("/speedOpt")
                  },
                  subNavigationItems: [
                    {
                      label: t("Site Speed Up"),
                      url: "/speedOpt/site-speedup",
                      matches: Boolean(path_url === "/speedOpt" || path_url === "/speedOpt/site-speedup"),
                      onClick: () => {
                        this.jumpPageUrl("/speedOpt/site-speedup")
                      }
                    },
                    {
                      label: t("Image Optimization"),
                      url: "/speedOpt/PageSpeed",
                      matches: Boolean(path_url === "/speedOpt/PageSpeed" || path_url === "/speedOpt/PageSpeed/details"),
                      onClick: () => {
                        this.jumpPageUrl("/speedOpt/PageSpeed")
                      }
                    },
                    {
                      label: t("AMP"),
                      // badge: this.state.isShowNavIcon ? newIcon : null,
                      // icon: AMPIcon,
                      url: "/speedOpt/seo-ant-amp",
                      matches: Boolean(path_url === "/speedOpt/seo-ant-amp"),
                      onClick: () => {
                        this.jumpPageUrl("/speedOpt/seo-ant-amp")
                      }
                    }
                  ],
                },
                {
                  label: t("Content Optimization"),
                  badge: this.state.isShowNavIcon ? aiIcon : null,
                  icon: OnpageIcon,
                  url: "/on-page-seo",
                  matches: Boolean(path_url === "/on-page-seo"),
                  onClick: () => {
                    this.jumpPageUrl("/on-page-seo")
                  }
                },
              ]}
            />
            <Navigation.Section
              separator
              // title={this.state.isShowNavIcon ? t("SEO BASIC") : t("SEO...")}
              items={[
                {
                  label: t("Search Appearance"),
                  icon: SearchAppearanceIcon,
                  url: "/searchAppearance",
                  matches: Boolean(path_url === "/searchAppearance"),
                  onClick: () => {
                    this.jumpPageUrl("/searchAppearance/image-alt-text")
                  },
                  subNavigationItems: [
                    {
                      label: t("Image alt text"),
                      // icon: EditMinor,
                      url: "/searchAppearance/image-alt-text",
                      matches: Boolean(path_url === "/searchAppearance/image-alt-text" || path_url === "/searchAppearance/PageSpeed/details"),
                      onClick: () => {
                        this.jumpPageUrl("/searchAppearance/image-alt-text")
                      }
                    },
                    {
                      label: t("Meta Tags"),
                      // icon: EditMinor,
                      url: "/searchAppearance/bulk-edit/manual-bulk-edit",
                      matches: Boolean(path_url === "/searchAppearance/bulk-edit/manual-bulk-edit"),
                      onClick: () => {
                        this.jumpPageUrl("/searchAppearance/bulk-edit/manual-bulk-edit")
                      }
                    },
                    {
                      label: t("JSON-LD"),
                      // icon: StructuredDataIcon,
                      url: "/searchAppearance/structured-data",
                      matches: Boolean(path_url === "/searchAppearance/structured-data"),
                      onClick: () => {
                        this.jumpPageUrl("/searchAppearance/structured-data")
                      }
                    },
                    {
                      label: t("Local Business"),
                      // icon: StructuredDataIcon,
                      url: "/searchAppearance/local-business",
                      matches: Boolean(path_url === "/searchAppearance/local-business"),
                      onClick: () => {
                        this.jumpPageUrl("/searchAppearance/local-business")
                      }
                    },
                    {
                      label: t("Instant Index"),
                      // icon: StructuredDataIcon,
                      url: "/searchAppearance/instant-index",
                      matches: Boolean(path_url === "/searchAppearance/instant-index"),
                      onClick: () => {
                        this.jumpPageUrl("/searchAppearance/instant-index")
                      }
                    },
                    {
                      label: t("Google Analytics"),
                      url: "/searchAppearance/GoogleSearchConsoleV2",
                      matches: Boolean(path_url === "/searchAppearance/GoogleSearchConsoleV2"),
                      onClick: () => {
                        this.jumpPageUrl("/searchAppearance/GoogleSearchConsoleV2")
                      }
                    }
                  ],
                },
                {
                  label: t("Link Management"),
                  icon: BrokenLinksIcon,
                  url: "/backlinks",
                  matches: Boolean(path_url === "/backlinks"),
                  onClick: () => {
                    this.jumpPageUrl("/backlinks/broken-link/view-errors")
                  },
                  subNavigationItems: [
                    {
                      label: t("Broken Links"),
                      // icon: BrokenLinksIcon,
                      url: "/backlinks/broken-link/view-errors",
                      matches: Boolean(path_url === "/backlinks/broken-link/view-errors" || path_url === "/backlinks/broken-link/manage-redirects" || path_url === "/backlinks/broken-link/ignore-page"),
                      onClick: () => {
                        this.jumpPageUrl("/backlinks/broken-link/view-errors")
                      }
                    },
                    {
                      label: t("Exchange Backlink"),
                      // badge: this.state.isShowNavIcon ? newIcon : null,
                      // icon: ExchangeIcon,
                      url: "/backlinks/exchange-backlink",
                      matches: Boolean(path_url === "/backlinks/exchange-backlink"),
                      onClick: () => {
                        this.jumpPageUrl("/backlinks/exchange-backlink")
                      }
                    },
                    {
                      label: t("Backlink Audit"),
                      // icon: BrokenLinksIcon,
                      url: "/backlinks/backlink-audit",
                      matches: Boolean(path_url === "/backlinks/backlink-audit"),
                      onClick: () => {
                        this.jumpPageUrl("/backlinks/backlink-audit")
                      }
                    },
                    {
                      label: t("HTML Sitemap"),
                      // icon: HTMLsitemapIcon,
                      url: "/backlinks/html-sitemap",
                      matches: Boolean(path_url === "/backlinks/html-sitemap"),
                      onClick: () => {
                        this.jumpPageUrl("/backlinks/html-sitemap")
                      }
                    },
                  ]
                },
                {
                  label: t("Keyword Research"),
                  icon: SEOCheckerIcon,
                  url: "/keywordRearch",
                  matches: Boolean(path_url === "/keywordRearch"),
                  onClick: () => {
                    this.jumpPageUrl("/keywordRearch/keywords-data")
                  },
                  subNavigationItems: [
                    {
                      label: t("Keywords"),
                      url: "/keywordRearch/keywords-data",
                      matches: Boolean(path_url === "/keywordRearch/keywords-data"),
                      onClick: () => {
                        this.jumpPageUrl("/keywordRearch/keywords-data")
                      }
                    },
                    {
                      label: t("Keywords Explore"),
                      url: "/keywordRearch/keywords-search",
                      matches: Boolean(path_url === "/keywordRearch/keywords-search"),
                      onClick: () => {
                        this.jumpPageUrl("/keywordRearch/keywords-search")
                      }
                    },
                    {
                      label: t("Competitors"),
                      url: "/keywordRearch/keywords-monitor",
                      matches: Boolean(path_url === "/keywordRearch/keywords-monitor"),
                      onClick: () => {
                        this.jumpPageUrl("/keywordRearch/keywords-monitor")
                      }
                    }
                  ],
                },
                // {
                //   label: t("Report"),
                //   icon: ReportIcon,
                //   url: "/reports",
                //   matches: Boolean(path_url === "/reports"),
                //   onClick: () => {
                //     this.jumpPageUrl("/reports")
                //   },
                // },
              ]}
            />
            <Navigation.Section
              // fill
              separator
              items={[
                {
                  label: t("Pricing"),
                  // badge: this.state.isShowNavIcon ? newIcon : null,
                  icon: PricingIcon,
                  url: "/plan",
                  matches: Boolean(path_url === "/plan"),
                  onClick: () => {
                    this.jumpPageUrl("/plan")
                  }
                },
              ]}
            />
            <Navigation.Section
              fill
              items={[
                {
                  label: t("Settings"),
                  icon: SettingsIcon,
                  url: "/settings",
                  matches: Boolean(path_url === "/settings"),
                  onClick: () => {
                    this.jumpPageUrl("/settings")
                  }
                }
              ]}
            />

          </Navigation>
        </div>
      </>
    ) : null;

    return navigationMarkup;
  }
}


export default withRouter(NavigationRoute);